export default {
  id: 244,
  title: 'Target #244 - Medusa',
  url: 'https://cssbattle.dev/play/244',
  colors: ['#D9D9D9', '#222222'],
  solution:
    '<p a><p b><p c><p d><p e><style>p[a],p[b]{top:44;background:#222}p[a],p[b],p[c]{background:#222}p[d],p[e]{background:#d9d9d9;width:30;height:10;top:134}body{background:#d9d9d9}p{position:fixed}p[a]{width:20;height:60;left:70;box-shadow:40px 0 #222,80px 0 #222,160px 0 #222,200px 0 #222,240px 0 #222}p[b]{width:40;height:20;left:50;box-shadow:60px 0 #222,180px 0 #222,260px 0 #222,40px 40px #222,220px 40px #222}p[c]{width:100;height:120;top:104;left:150;border-radius:0 0 1in 1in}p[d]{left:160;transform:rotate(15deg)}p[e]{left:210;transform:rotate(-15deg)',
}
